import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigate, Link } from 'react-router-dom';
import HomeContainer from '../components/HomeContainer';
import '../styles/Home.css';

// Import icons from lucide-react
import { Target, Lightbulb, TrendingUp, Rocket } from 'lucide-react';

export class Home extends Component {
    static propTypes = {
        auth: PropTypes.object.isRequired
    };

    
    render() {
        const { isAuthenticated, user, isLoading } = this.props.auth;

        // Show loading spinner while authenticating
        if (isLoading) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-white">
                    <div className="text-center">
                        <svg className="animate-spin h-12 w-12 text-[#1db5d4] mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <p className="text-gray-600 text-lg">Authenticating...</p>
                    </div>
                </div>
            );
        }

        // If user is authenticated and is a student who needs onboarding, redirect
        if (isAuthenticated && user && user.role === 'student' && !user.hasCompletedOnboarding && user.group) {
            return <Navigate to="/onboarding" replace />;
        }

        // If user is authenticated and not a student or has completed onboarding, redirect to dashboard
        if (isAuthenticated && user && (user.role !== 'student' || user.hasCompletedOnboarding)) {
            return <Navigate to="/dashboard" replace />;
        }

        const Home1 = (
            <Fragment>
                <div className="min-h-[calc(100vh-4rem)] flex items-center bg-white relative py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            {/* Left Content */}
                            <div className="space-y-8">
                                <div>
                                    <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
                                        Master New Skills
                                        <br />
                                        <span className="text-[#1db5d4]">Anytime, Anywhere</span>
                                    </h1>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <Link to="/register" className="bg-[#1db5d4] hover:bg-[#16a2c7] text-white font-semibold py-4 px-10 rounded-lg transition-colors duration-200 text-center">
                                        Register
                                    </Link>
                                    <Link to="/contact-help" className="border-2 border-[#1db5d4] text-[#1db5d4] hover:bg-[#1db5d4] hover:text-white font-semibold py-4 px-10 rounded-lg transition-colors duration-200 text-center">
                                        Contact us
                                    </Link>
                                </div>

                                {/* Powered by text */}
                                <div className="text-gray-700 text-lg">
                                    powered by Your Big Year®
                                </div>
                            </div>

                            {/* Right Content - Feature Grid */}
                            <div className="grid grid-cols-2 gap-6">
                                {/* Set your goals */}
                                <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-[#1db5d4] transition-colors duration-200">
                                    <Target className="text-[#1db5d4] w-12 h-12 mb-4" />
                                    <h3 className="text-gray-900 font-semibold text-lg mb-2">Set your goals</h3>
                                </div>

                                {/* Learn critical skills */}
                                <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-[#1db5d4] transition-colors duration-200">
                                    <Lightbulb className="text-[#1db5d4] w-12 h-12 mb-4" />
                                    <h3 className="text-gray-900 font-semibold text-lg mb-2">Learn critical skills</h3>
                                </div>

                                {/* Track your progress */}
                                <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-[#1db5d4] transition-colors duration-200">
                                    <TrendingUp className="text-[#1db5d4] w-12 h-12 mb-4" />
                                    <h3 className="text-gray-900 font-semibold text-lg mb-2">Track your progress</h3>
                                </div>

                                {/* Jump start your career */}
                                <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-[#1db5d4] transition-colors duration-200">
                                    <Rocket className="text-[#1db5d4] w-12 h-12 mb-4" />
                                    <h3 className="text-gray-900 font-semibold text-lg mb-2">Jump start your career</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
      
        const Home2 = (
            <Fragment>
                <HomeContainer/>
            </Fragment>
        );
        
        return (
            <div className="home-container w-full">
                {isAuthenticated ? Home2 : Home1}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(Home)
